import { Injectable } from "@angular/core";
import { MsalGuardConfiguration, MsalInterceptorConfiguration } from "@azure/msal-angular";
import { BrowserCacheLocation, InteractionType, IPublicClientApplication, PublicClientApplication } from "@azure/msal-browser";
import { AppConfigService } from "~/core/services/appconfig.service";

@Injectable({
    providedIn: 'root'
})
export class AuthFactories {
    public initializerFactory(config: AppConfigService) {
        let promise = config.init();
        return () => promise;
    }

    public MSALInstanceFactory(config: AppConfigService): IPublicClientApplication {
        // Determine redirect URI based on environment

        return new PublicClientApplication({
            auth: {
                clientId: config.getConfig("clientId"),
                authority: "https://login.microsoftonline.com/" + config.getConfig("tenantId"),
                redirectUri: '/',
                postLogoutRedirectUri: '/',
                navigateToLoginRequestUrl: true
            },
            cache: {
                cacheLocation: BrowserCacheLocation.SessionStorage,
                temporaryCacheLocation: BrowserCacheLocation.SessionStorage,
                storeAuthStateInCookie: false,
                secureCookies: true
            },
            system: {
                allowNativeBroker: false, // Disables WAM Broker
                loggerOptions: undefined
            }
        })
    }

    public MSALGuardConfigFactory(config: AppConfigService): MsalGuardConfiguration {
        return {
            interactionType: InteractionType.Redirect,
            authRequest: {
                scopes: [`${config.getConfig("clientId")}/.default`]
            },
            loginFailedRoute: '/'
        }
    }

    public MSALInterceptorConfigFactory(config: AppConfigService): MsalInterceptorConfiguration {
        const protectedResourceMap = new Map<string, Array<string>>();

        // Protect backend API calls with MSAL token
        const apiUrl = config.getConfig("apiUrl");
        if (apiUrl) {
            protectedResourceMap.set(`${apiUrl}/*`, [`${config.getConfig("clientId")}/.default`]);
        }
        // NOTE: Removed Microsoft Graph API protection
        // If you need to call Microsoft Graph, you'll need to:
        // 1. Add "user.read" permission in Azure AD app registration
        // 2. Grant admin consent
        // 3. Use acquireTokenSilent() with scope 'user.read' separately

        return {
            // Use Popup for token acquisition in interceptor to avoid redirect loops
            // The initial login uses Redirect (configured in MSALGuardConfigFactory)
            // But silent token renewal in interceptor should NOT trigger a full page redirect
            interactionType: InteractionType.Popup,
            protectedResourceMap: protectedResourceMap
        }
    }
}